module.exports = __webpack_public_path__ + "static/media/chebaoluo.7313f1c4.png";